<template>
  <div class="auto-fit">
    <slot />
  </div>
</template>

<script>
import fitty from 'fitty';

export default {
  mounted() {
    fitty(this.$el, {
      maxSize: 64,
    });
  }
}
</script>

<style scoped>
	.auto-fit {
		/* Recommended for auto-fitting */
		display: inline-block;
		white-space: nowrap;

		/* Slight adjustment due to using a custom font (and probably because it is fit within a circle) */
		padding: 4px;
	}
</style>